import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import classnames from 'classnames';

const alertQueueIconCssClass = 'alert-queue-icon';
const alertCssClasses = {
  Critical: 'critical',
  Warning: 'warning',
  Opportunity: 'opportunity',
  Information: 'info',
};

function PreviewBarInner(props) {
  const dismissHandler = (e) => {
    e.stopPropagation();
    props.dismissAction();
  };

  const { items } = props;

  return (
    /* eslint jsx-a11y/click-events-have-key-events: 0 */
    /* eslint jsx-a11y/no-static-element-interactions: 0 */
    items.length > 0 ? (
      <div className={classnames('preview-bar', `${alertCssClasses[props.items[0].severity]}-level`)} onClick={props.viewMoreAction} data-testid="preview-bar">
        {
          items.map(item => (
            <React.Fragment key={item.severity}>
              <span className={classnames(alertQueueIconCssClass, `${alertQueueIconCssClass}-${alertCssClasses[item.severity]}`)} />
              <span className={classnames('preview-bar-content', { 'preview-bar-content-multi-item': items.length > 1 })}>{item.content}</span>
            </React.Fragment>
          ))
        }
        {
        (items.length === 1 && props.notificationCount > 1) ?
          <button className={classnames('preview-bar-view-more', 'btn', 'btn-link')} type="button">{props.viewMoreText}</button>
            : null
        }
        <button className={classnames('close', 'dismiss', 'closeimage', 'disableEsc', 'clickable', 'btn')} tabIndex="0" onClick={dismissHandler} aria-label={props.i18n.getString(_TL_('Close the preview bar'))} />
      </div>
    ) : null
  );
}

PreviewBarInner.defaultProps = {
  items: [],
  viewMoreAction: _.noop,
  dismissAction: _.noop,
};

PreviewBarInner.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    severity: PropTypes.oneOf(['Critical', 'Warning', 'Opportunity', 'Information']).isRequired,
    content: PropTypes.string.isRequired,
  })),
  notificationCount: PropTypes.number.isRequired,
  viewMoreText: PropTypes.string.isRequired,
  viewMoreAction: PropTypes.func,
  dismissAction: PropTypes.func,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
};

export const PreviewBar = PreviewBarInner;
